import { render, staticRenderFns } from "./Subjectsetup.vue?vue&type=template&id=0e2ae7ab"
import script from "./Subjectsetup.vue?vue&type=script&lang=js"
export * from "./Subjectsetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports